<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        Cadastrar nova Tag
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
        >
          <v-text-field
            v-model="name"
            :rules="rulesName"
            :error-messages="formError.name"
            label="Nome"
            @input="formError.name = ''"
          />
          <v-select
            v-model="tagtype"
            :items="tagtypes"
            :rules="rulesTagType"
            item-text="name"
            item-value="id"
            label="Tipo de Tag"
          />
        </v-form>
      </v-card-text>
      <v-card-text>
        <div class="d-flex justify-space-between">
          <v-btn
            color="primary"
            text
            @click="onCancel"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="save()"
          >
            Salvar Tag
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {
  },
  props: {
    title: { type: String, default: undefined },
    id: { type: Number, default: undefined }
  },
  data: () => ({
    rulesName: [
      value => !!value || 'Preenchimento obrigatório.',
      value => (value && value.length >= 3) || 'Min 3 caracteres'
    ],
    rulesTagType: [
      value => !!value || 'Preenchimento obrigatório.'
    ],
    formError: [],
    tagtypes: [],
    tagtype: '',
    name: ''
  }),
  async created () {
    await this.getTagTypes()
  },
  methods: {
    async getTagTypes () {
      try {
        this.tagtypes = await this.$api.getTagTypes()
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Erro ao obter tipos de tags.', color: 'red' })
      }
    },
    validate () {
      return this.$refs.form.validate()
    },

    async save () {
      const validate = await this.validate()
      if (validate === false) {
        return false
      }
      const data = {
        name: this.name,
        tag_type_id: this.tagtype
      }
      this.onSubmit(data)
    },

    onCancel () {
      this.$emit('resolve', false)
    },

    onSubmit (tagType) {
      this.$emit('resolve', tagType)
    }
  }
}
</script>
